module.exports = __webpack_public_path__ + "static/media/logo-footer.985bfbd4.svg";